import type { TableOfContent } from '@openclassrooms/sdk-web';

const isPartType = ({ type }: TableOfContent) => type === 'title-2' || type === 'MCQ';

const getNextPartFromToc = (flatTableOfContent: TableOfContent[]): TableOfContent | undefined => {
  const firstNotPassedPart = flatTableOfContent.find(
    (part) => isPartType(part) && part.learningActivityStatus !== 'passed'
  );

  const firstPart = flatTableOfContent.find(isPartType);

  return firstNotPassedPart || firstPart;
};

export default getNextPartFromToc;
